export default {
  role: {
    search: {
      companyName: '公司名称',
      companyPlaceholder: '请选择公司',
      applicationName: '应用名称',
      applicationPlaceholder: '请选择应用',
      roleName: '角色名称',
      rolePlaceholder: '请输入角色名称',
    },
    table: {
      roleName: '角色名称',
      companyName: '公司名称',
      applicationName: '应用名称',
      remark: '备注',
    },
    insertTitle: '新增角色',
    companyName: '公司名称',
    namePlaceholder: '请选择公司',
    applicationName: '应用名称',
    appPlaceholder: '请选择应用',
    remark: '备注',
    remarkPlaceholder: '请输入备注',
    roleName: '角色名称',
    roleNamePlaceholder: '请输入角色名称',
    rolenameNotEmpty: '角色名称不能为空',
    companynameNotEmpty: '公司名称不能为空',
    applicationNameNotEmpty: '应用名称不能为空',
    editTitle: '修改角色',
    detialTitle: '菜单授权-',
    authRoleTips: '请选择一个角色进行授权',
    deleteTips: '请选择要删除的角色',
  },
};
